import { render } from "./ResumeRoute.vue?vue&type=template&id=cab3fd16"
import script from "./ResumeRoute.vue?vue&type=script&lang=js"
export * from "./ResumeRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__